/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from "react"
import { HashRouter, Route } from "trux"

import SwapPlayer from "./containers/SwapPlayer"
import AddPlayer from "./containers/AddPlayer"
import EditPlayer from "./containers/EditPlayer"
import RosterList from "./containers/RosterList"

import "./Rosters.css"

// url like
// https://go.traceup.com/rosters/team#/kwrk23

export default class Rosters extends Component {
    render() {
        return (
            <HashRouter>
                <div data-trk-ctx="Rosters" className="Rosters">
                    <Route
                        path="/:team/rosters/:roster_type/:roster_id"
                        component={RosterList}
                    />

                    <Route
                        exact
                        path="/:team/rosters/:roster_type/:roster_id/players/:player_id/edit"
                        component={EditPlayer}
                    />

                    <Route
                        exact
                        path="/:team/rosters/:roster_type/:roster_id/players/:player_id/swap"
                        component={SwapPlayer}
                    />

                    <Route
                        exact
                        path="/:team/rosters/:roster_type/:roster_id/players/:player_id/swap/:to_trace_number"
                        component={SwapPlayer}
                    />

                    <Route
                        exact
                        path="/:team/rosters/:roster_type/:roster_id/players/add/:trace_number"
                        component={AddPlayer}
                    />
                </div>
            </HashRouter>
        )
    }
}
